import { CartFormDataItem, DeliveryOption } from "../../types/cart";
import cart2Core from "../../core/cart2.core";
import { useQuery } from "@tanstack/react-query";

export default function useGetShipOptions(selectedCartItems: CartFormDataItem[], cartIsLoading: boolean) {
  const cartItemIds = selectedCartItems.map((i) => i.id).filter((i) => i !== undefined && i !== null);

  return useQuery({
    queryKey: ["ShippingDeliveryOptions", cartItemIds],
    queryFn: async () => {
      const shippingFees = await cart2Core.getShipOptions({
        countryCode: "HK",
        cartItemIds,
      });

      const eligible = shippingFees.filter((f) => f.eligible);

      // Create delivery options array
      const options: DeliveryOption[] = [
        ...eligible.map((fee) => ({
          id: fee.shipOptionId,
          label: fee.optionName,
          shipType: fee.shipType,
          fee: fee.fee,
        })),
      ];

      return { deliveryOptions: options, shippingFees };
    },
    enabled: !!selectedCartItems.length && !cartIsLoading && cartItemIds.length > 0,
  });
}
